const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/review/v1frontend/review-complaint/create', params)
  },
  // comStatus
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/review/v1frontend/review-complaint/search', { params })
  },
  // comid
  delete ({ state, commit, rootState }, params) {
    return rootState.axios.post('/review/v1frontend/review-complaint/delete', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
